export const apiEndpoints = {
  monitoring: () => ({
    entries: () => ({
      list: () => "monitoring/",
      create: () => "monitoring/",
    }),
    uploadBatch: () => "monitoring/api/batch/upload/",
    batches: () => ({
      list: () => "monitoring/batch/",
    }),
    statistics: () => "monitoring/statistics/",
    statisticsWithPeriod: () => "monitoring/statistics/period/",
    export: () => "monitoring/export/results/",
    bulkDelete: () => "monitoring/bulk-delete/",
    bulkUpdateStatus: () => "monitoring/result/bulk-update-status/",
    matches: () => ({
      list: (entryId: string) => `monitoring/${entryId}`,
      results: (entryId: string) => `monitoring/${entryId}/results/`,
      update: (matchId: string) => `monitoring/api/result/${matchId}/`,
      report: (entryId: string) => `monitoring/${entryId}/report/`,
    }),
  }),
  searchConfigurations: () => ({
    company: () => ({
      list: () => "/company/search-config/",
      create: () => "/company/search-config/",
      update: (id: string) => `/company/search-config/${id}/`,
      delete: (id: string) => `/company/search-config/${id}/`,
      audits: (id: string) => `/company/search-config/${id}/audits/`,
    }),
    user: () => ({
      list: () => "/search-configurations/user/",
      create: () => "/search-configurations/user/",
      update: (id: string) => `/search-configurations/user/${id}/`,
      delete: (id: string) => `/search-configurations/user/${id}/`,
    }),
  }),
  recentSearches: () => ({
    list: () => "/search/latests/",
  }),
  screening: () => ({
    search: () => "/search/",
    report: (searchId: string) => `/search/report/${searchId}/`,
  }),
  contracts: () => ({
    list: () => "/contracts/",
  }),
  company: () => ({
    detail: () => "/company/",
    update: () => "/company/",
    config: () => ({
      detail: () => "/company/config/",
      update: () => "/company/config/",
    }),
    contracts: () => ({
      list: () => "/company/contracts/",
      create: () => "/company/contracts/",
    }),
    users: () => ({
      list: () => "/user/",
      create: () => "/user/",
      detail: (uuid: string) => `/user/${uuid}`,
      update: (uuid: string) => `/user/${uuid}`,
      delete: (uuid: string) => `/user/${uuid}`,
    }),
  }),
  dashboard: () => ({
    counts: () => "/searches/count/",
  }),
  account: () => ({
    user: () => ({
      update: (uuid: string) => `/user/${uuid}`,
      optOut: (uuid: string) => `/user/${uuid}`,
    }),
  }),
  adverseMedia: () => ({
    search: () => "search/media",
  }),
  info: () => ({
    get: () => "/info/",
  }),
  notifications: () => ({
    list: () => "/notifications/",
    acknowledge: (id: string) => `/notifications/${id}/acknowledge/`,
  }),
  webhooks: () => ({
    list: () => "/company/webhooks/",
    create: () => "/company/webhooks/",
    update: (id: string) => `/company/webhooks/${id}`,
    delete: (id: string) => `/company/webhooks/${id}`,
    ping: (id: string) => `/company/webhooks/${id}/ping`,
  }),
  batch: () => ({
    list: () => "/search/batch/",
    detail: (id: string) => `/search/batch/${id}/`,
    upload: () => "/search/batch/upload/",
    delete: (id: string) => `/api/search/batch/${id}/`,
  }),
  sso: () => ({
    socialApplications: () => "/social-application/",
    socialAccounts: () => ({
      list: () => "/social-account/",
      delete: (id: string) => `/social-account/${id}/`,
    }),
  }),
  dataSources: () => ({
    list: () => "/sources/",
  }),
  apiTokens: () => ({
    list: () => "/tokens/",
    create: () => "/tokens/",
    delete: (key: string) => `/tokens/${encodeURIComponent(key)}`,
    setDefault: (key: string) => `/tokens/${encodeURIComponent(key)}/set_default/`,
  }),
  auth: () => ({
    login: () => "/api/users/login/",
    loginOtp: () => "/api/users/login/otp/",
    signup: () => "/api/users/signup/",
    passwordReset: () => "/api/users/password-reset/",
    passwordResetConfirm: () => "/api/users/password-reset/confirm/",
    logout: () => "/api/users/logout/",
    info: () => "/info/",
  }),
};
